'use strict'

import {
	sanitize,
	runTests,
} from '@/state/utilities/forms';

import { roles } from '@/roles';

export const workWeekOpts = [
	'Monday—Friday',
	'Tuesday—Saturday',
	'Wednesday—Sunday',
	'Thursday—Monday',
	'Friday—Tuesday',
	'Saturday—Wednesday',
	'Sunday—Thursday',
];

export const roleOpts = Object.entries(roles).reduce(
	(opts, [ value, config ]) => {
		if (value === 'guest') {
			return opts;
		}
		return [
			...opts,
			{
				label: config.label,
				value,
			},
		];
	},
	[]
);

export const formConfig = {
	sanitize: (fieldConfigs, input) => {
		return sanitize(fieldConfigs, input);
	},
	validate: (fieldConfigs, input) => {

		const report = runTests(fieldConfigs, input);
		const reportM = Object.fromEntries(report);

		const { passphrase, confirmPassphrase } = input;

		if (passphrase !== confirmPassphrase) {
			reportM.confirmPassphrase.success = false;
			reportM.confirmPassphrase.testResults = [
				{
					success: false,
					message: 'Passphrase doesn\'t match',
				},
			];
		}

		return Object.entries(reportM);
	},
	fields: {
		firstName: {
			sanitize: v => v.trim(),
			tests: [
				{
					test: v => /^[ -~]{1,32}$/.test(v),
					message: 'Required field',
				},
			],
		},
		lastName: {
			sanitize: v => v.trim(),
			tests: [
				{
					test: v => /^[ -~]{1,32}$/.test(v),
					message: 'Required field',
				},
			],
		},
		username: {
			sanitize: v => v.trim(),
			tests: [
				{
					test: v => /^[a-z]{4,16}[\d]{0,4}$/.test(v),
					message: 'Usernames must be 4-16 alphanumeric characters',
				},
			],
		},
		passphrase: {
			sanitize: v => v.trim(),
			tests: [
				{
					test: v => /^[ -~]{5,16}$/.test(v),
					message: 'Passphrases must be 5-16 printable characters',
				},
			],
		},
		confirmPassphrase: {
			sanitize: v => v.trim(),
			tests: [
			],
		},
		office: {
			sanitize: v => v,
			tests: [
				{
					test: v => !!v,
					message: 'Required field',
				},
			],
		},
		roles: {
			sanitize: v => v,
			tests: [
				{
					test: v => v.length,
					message: 'Required field',
				},
			],
		},
		workWeek: {
			sanitize: v => v,
			tests: [
				{
					test: v => !!v,
					message: 'Must choose one',
				},
			],
		},
	},
};
